export function parseHorizonsTimeUtc(timeStr: string): Date | null {
  // Parse Horizons format: "2025-Dec-12 00:00"
  const trimmed = timeStr.trim()
  const spaceIndex = trimmed.indexOf(" ")
  if (spaceIndex === -1) return null

  const datePart = trimmed.substring(0, spaceIndex)
  const timePart = trimmed.substring(spaceIndex + 1)

  const dateMatch = datePart.match(/^(\d{4})-(\w{3})-(\d{1,2})$/)
  if (!dateMatch) return null

  const year = parseInt(dateMatch[1], 10)
  const monthStr = dateMatch[2]
  const day = parseInt(dateMatch[3], 10)

  const months: Record<string, number> = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  }
  const month = months[monthStr]
  if (month === undefined) return null

  const timeMatch = timePart.match(/^(\d{1,2}):(\d{2})$/)
  if (!timeMatch) return null

  const hours = parseInt(timeMatch[1], 10)
  const minutes = parseInt(timeMatch[2], 10)

  return new Date(Date.UTC(year, month, day, hours, minutes, 0))
}

export function formatTimeForDisplay(
  date: Date,
  timezone: string | null
): string {
  const options: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }

  if (timezone) {
    return new Intl.DateTimeFormat("en-US", {
      ...options,
      timeZone: timezone,
    }).format(date)
  }

  // Browser's local timezone
  return new Intl.DateTimeFormat("en-US", options).format(date)
}

export function getDayOffset(utcDate: Date, timezone: string | null): number {
  const utcYear = utcDate.getUTCFullYear()
  const utcMonth = utcDate.getUTCMonth()
  const utcDay = utcDate.getUTCDate()

  let tzYear: number
  let tzMonth: number
  let tzDay: number

  if (timezone) {
    const tzParts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
    }).formatToParts(utcDate)

    tzYear = parseInt(tzParts.find(p => p.type === "year")?.value || "0", 10)
    tzMonth =
      parseInt(tzParts.find(p => p.type === "month")?.value || "0", 10) - 1
    tzDay = parseInt(tzParts.find(p => p.type === "day")?.value || "0", 10)
  } else {
    tzYear = utcDate.getFullYear()
    tzMonth = utcDate.getMonth()
    tzDay = utcDate.getDate()
  }

  const utcDateOnly = new Date(Date.UTC(utcYear, utcMonth, utcDay))
  const tzDateOnly = new Date(Date.UTC(tzYear, tzMonth, tzDay))

  const diffMs = tzDateOnly.getTime() - utcDateOnly.getTime()
  return Math.round(diffMs / (1000 * 60 * 60 * 24))
}

export function formatTimeForDisplayUTC(utcTime: string): string {
  const date = parseHorizonsTimeUtc(utcTime)
  if (!date) {
    const spaceIndex = utcTime.indexOf(" ")
    if (spaceIndex !== -1) return utcTime.substring(spaceIndex + 1)
    return utcTime
  }
  return formatTimeForDisplay(date, "UTC")
}

export function getTimezoneOffsetLabel(timezone: string | null): string {
  const now = new Date()

  if (timezone) {
    const utcParts = new Intl.DateTimeFormat("en-US", {
      timeZone: "UTC",
      hour: "numeric",
      hour12: false,
    }).formatToParts(now)

    const tzParts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      hour: "numeric",
      hour12: false,
    }).formatToParts(now)

    const utcHour = parseInt(
      utcParts.find(p => p.type === "hour")?.value || "0",
      10
    )
    const tzHour = parseInt(
      tzParts.find(p => p.type === "hour")?.value || "0",
      10
    )

    let offsetHours = tzHour - utcHour
    if (offsetHours > 12) offsetHours -= 24
    if (offsetHours < -12) offsetHours += 24

    if (offsetHours === 0) return "UTC"
    const sign = offsetHours >= 0 ? "+" : ""
    return `UTC${sign}${offsetHours}`
  }

  const offsetMinutes = now.getTimezoneOffset()
  const offsetHours = -offsetMinutes / 60
  if (offsetHours === 0) return "UTC"
  const sign = offsetHours >= 0 ? "+" : ""
  return `UTC${sign}${Math.floor(offsetHours)}`
}



